import { render, staticRenderFns } from "./UsersGuide.vue?vue&type=template&id=be4235fc&scoped=true"
import script from "./UsersGuide.vue?vue&type=script&lang=js"
export * from "./UsersGuide.vue?vue&type=script&lang=js"
import style0 from "./UsersGuide.vue?vue&type=style&index=0&id=be4235fc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4235fc",
  null
  
)

export default component.exports